
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetPatientOdOs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isOd"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isOs"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setPatientOdOs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_patientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_isOd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isOd"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_isOs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isOs"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patient"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deactivatedDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"appUserId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"appTenantId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isOd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isOs"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1140}};
    doc.loc.source = {"body":"mutation SetPatientOdOs (\n  $patientId: String!\n  $isOd: Boolean!\n  $isOs: Boolean\n) {\n  setPatientOdOs(input: {\n    _patientId: $patientId\n    _isOd: $isOd\n    _isOs: $isOs\n  }) {\n    patient {\n      id\n      createdDate\n      deactivatedDate\n      appUserId\n      appTenantId\n      isOd\n      isOs\n#      appUser: appUserByAppUserId {\n#        id\n#        recoveryEmail\n#        inactive\n#        extAuthId\n#        extAuthBlocked\n#        licensingStatus\n#        permissions\n#        permissionKey\n#        preferredLanguage: supportedLanguageByLanguageId {\n#          id\n#          name\n#        }\n#        auth0Info\n#        licenses: activeLicenses {\n#          nodes {\n#            id\n#            name\n#            licenseTypeKey\n#            expirationDate\n#            createdAt\n#            inactive\n#          }\n#        }\n#        linkedOldUser: oldUserByAppUserId {\n#          memberId\n#          firstName\n#          lastName\n#          email\n#        }\n#      }\n#      contact: contactByContactId {\n#        id\n#        firstName\n#        lastName\n#        email\n#        cellPhone\n#        officePhone\n#      }\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SetPatientOdOs"] = oneQuery(doc, "SetPatientOdOs");
        
